import SummarySkeleton from "./summarySkeleton";
import { useTranslation } from "react-i18next";
import { FormatCalendar, extractIp } from "../../redux/utils";
import { Link } from "react-router-dom";
import { HiRefresh } from "react-icons/hi";
import { safeHtml } from "../../utils/sanitize";
import { customToast } from "../common/customToast";

// Geriye dönük uyumluluk: customToast eskiden bu dosyadan dışa aktarılıyordu.
export { customToast } from "../common/customToast";

const BranchCard = ({ branch, allSummaryData, handleSummaryClick }) => {
  const { t } = useTranslation();

  const formatDate = (date) => {
    const match = String(date || "").match(/\d+/);
    if (!match) return "";
    return FormatCalendar(new Date(Number(match[0])), ".", false, false);
  };

  const summary = allSummaryData?.[branch.ipAddress];
  const isLicensed = branch.status === 1;
  const reachable = Boolean(summary?.success) && isLicensed;
  const data = summary?.data;

  const handleBranchDetails = () => {
    if (!reachable) {
      customToast(t("branches.inActive", { branch: "" }));
    }
  };

  return (
    <div className="bg-[var(--nav-txt)] h-max flex flex-col rounded-[8px] shadow-sm shadow-[var(--sh-1)] relative">
      <div
        className="h-[160px] md:h-[250px] truncate rounded-b cursor-pointer"
        onClick={handleBranchDetails}
      >
        <Link
          to={`/info/${extractIp(branch.ipAddress)}`}
          className={reachable ? "" : "pointer-events-none"}
          aria-disabled={!reachable}
          tabIndex={reachable ? 0 : -1}
        >
          <img
            src={`https://liwapos.com/Image/customersImage/${branch.branch_image}`}
            alt={branch.name}
            className="h-full w-full object-cover mb-4 md:mb-0 hover:scale-105 duration-1000 cursor-pointer transition-all ease-in-out"
          />
        </Link>
      </div>
      <div className="px-3 pt-3 pb-2 flex flex-col text-[var(--tx-3)] product-info">
        <div className="flex items-start justify-between gap-2 mb-1">
          <h3
            className="Poppins font-bold text-base text-[--gr-9] truncate"
            title={branch.name}
          >
            {branch.name}
          </h3>
          <span
            className={`shrink-0 inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium ${
              isLicensed
                ? "bg-green-500/15 text-green-600"
                : "bg-red-500/15 text-red-500"
            }`}
          >
            <span
              className={`h-1.5 w-1.5 rounded-full ${
                isLicensed ? "bg-green-500" : "bg-red-500"
              }`}
              aria-hidden="true"
            />
            {isLicensed ? t("common.active") : t("common.inactive")}
          </span>
        </div>
        <p className="Poppins text-xs text-[--tx-3]">
          {t("branches.licence")} · {t("branches.endDate")}:{" "}
          <span className="text-[--gr-9] font-medium">
            {formatDate(branch.endDate)}
          </span>
        </p>
        <div className="mb-1 w-full">
          {allSummaryData && (
            <div className="w-full Poppins overflow-x-auto py-3 rounded-lg text-base font-semibold bg-[--btn-txt] mt-2 border border-solid border-[--gr-2]">
              {summary?.loading ? (
                <div className="px-3">
                  <SummarySkeleton />
                </div>
              ) : summary?.success && typeof data === "object" ? (
                <Summary data={data} />
              ) : (
                <div className="Poppins flex items-center justify-between px-3">
                  <p className="text-red-400 font-medium">
                    {t("common.offline")}
                  </p>
                  <button
                    type="button"
                    aria-label={t("common.retry")}
                    title={t("common.retry")}
                    className="text-3xl cursor-pointer text-[--tx-3] hover:text-[--primary] bg-transparent flex items-center rounded-full"
                    onClick={() => handleSummaryClick(branch.ipAddress)}
                  >
                    <HiRefresh aria-hidden="true" />
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const Summary = ({ data }) => {
  const summaryTable = data?.tables?.[0]?.rows || [];

  return (
    <div>
      <table className="w-full h-max text-sm text-left rtl:text-right text-[--gr-5] border border-solid border-[--btn-txt]">
        <tbody>
          {summaryTable.map((cell, index) => (
            <tr className="odd:bg-[--btn-txt] even:bg-[--gr--0]" key={index}>
              {cell.cells.map((rowItem, cellIndex) => (
                <td
                  key={cellIndex}
                  className="py-2 px-3 font-medium text-[--gr-9] whitespace-nowrap odd:text-left even:text-right"
                  dangerouslySetInnerHTML={safeHtml(rowItem)}
                ></td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BranchCard;
